import styled from 'styled-components';

export const TableWrapper = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
`;

// Shown on top of the (stale) rows while new data loads after a page/sort/search/filter change.
export const RefreshingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  pointer-events: none;
  background: rgba(255, 255, 255, 0.6);
`;

export const AlignRightHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  z-index: 10;
`;
